import { motion, AnimatePresence } from "framer-motion";
import { Tag } from "lucide-react";
import { ProductCard } from "./ProductCard";

export const PromoSection = ({ products, onQuickView, onAdd }) => {
  if (!products.length) return null;
  return (
    <section
      id="promociones"
      data-testid="promo-section"
      className="border-y border-amber-200/60 bg-amber-50/70 dark:border-amber-500/10 dark:bg-amber-500/5"
    >
      <div className="mx-auto max-w-7xl px-6 py-24">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="mb-12 flex flex-col gap-4"
        >
          <p className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-amber-700 dark:text-amber-400">
            <Tag size={13} /> Promoción especial
          </p>
          <h2 className="font-serif text-3xl font-light tracking-tight text-stone-900 dark:text-stone-50 sm:text-4xl lg:text-5xl">
            Lámparas en oferta
          </h2>
          <p className="max-w-md text-base text-stone-600 dark:text-stone-300">
            Piezas escultóricas en promoción, por tiempo limitado.
          </p>
        </motion.div>
        <motion.div layout className="grid grid-cols-1 gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-4">
          <AnimatePresence mode="popLayout">
            {products.map((p) => (
              <ProductCard key={p.id} product={p} onQuickView={onQuickView} onAdd={onAdd} />
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>
  );
};
